import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosSharedModule } from '../shared/module'
import { IcosButtonsModule } from '../button/module'
import { IcosForm } from './form'
import { IcosFormItem } from './form-item'

@NgModule({
  declarations: [IcosForm, IcosFormItem],
  exports: [IcosForm, IcosFormItem],
  imports: [CommonModule, IcosButtonsModule, IcosSharedModule],
  entryComponents: [IcosForm],
})
export class IcosFormModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosFormModule, providers: [] }
  }
}
